<template>
  <div 
    :class="{
      'group': true,
      'collapse': collapsible,
      'shown': !internalCollapsed,
      'hidden': internalCollapsed,
    }">
    <h1 v-if="header" class="header group__header">
      <button 
        v-if="collapsible" 
        type="button" 
        class="collapse-icon" 
        @click="onClickCollapse()">
        <span :class="{
          'ui-icon': true,
          'ui-icon-triangle-1-n': !internalCollapsed,
          'ui-icon-triangle-1-s': internalCollapsed,
        }">{{internalCollapsed ? 'Show Group Contents' : 'Hide Group Contents'}}</span>
      </button>
      <span class="header__text">{{header}}</span>
    </h1>
    <div class="rect group__inner">
      <slot></slot>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupComponent",
  props: {
    header: String,
    collapsed: Boolean,
    collapsible: Boolean,
  },
  data() {
    return {
      internalCollapsed: this.collapsed,
    };
  },
  watch: {
    collapsed() {
      if (this.internalCollapsed !== this.collapsed) {
        this.internalCollapsed = this.collapsed;
      }      
    },
  },
  methods: {
    onClickCollapse() {
      this.internalCollapsed = !this.internalCollapsed;
    }
  },
}
</script>